import { motion } from "framer-motion";

/**
 * GlassLayout - Wrapper cu fundal liquid glass animat
 * Adaugă orbe colorate animate și fundal gradient luminos
 */
export default function GlassLayout({ children, className = "", variant = "default" }) {
  const orbConfigs = {
    default: [
      { color: "#93c5fd", size: 600, x: "-10%", y: "-10%", dx: [0, 60, 0], dy: [0, 40, 0], dur: 14 },
      { color: "#fdba74", size: 500, x: "70%", y: "60%", dx: [0, -50, 0], dy: [0, -60, 0], dur: 17 },
      { color: "#a78bfa", size: 400, x: "50%", y: "-5%", dx: [0, -30, 0], dy: [0, 40, 0], dur: 20 },
      { color: "#5eead4", size: 350, x: "10%", y: "70%", dx: [0, 40, 0], dy: [0, -30, 0], dur: 16 },
    ],
    worker: [
      { color: "#5eead4", size: 600, x: "-5%", y: "-10%", dx: [0, 50, 0], dy: [0, 40, 0], dur: 15 },
      { color: "#93c5fd", size: 450, x: "75%", y: "50%", dx: [0, -40, 0], dy: [0, -50, 0], dur: 18 },
      { color: "#c4b5fd", size: 350, x: "40%", y: "80%", dx: [0, 30, 0], dy: [0, -40, 0], dur: 13 },
    ],
    superadmin: [
      { color: "#fbbf24", size: 550, x: "-5%", y: "-10%", dx: [0, 60, 0], dy: [0, 50, 0], dur: 16 },
      { color: "#818cf8", size: 500, x: "70%", y: "55%", dx: [0, -50, 0], dy: [0, -40, 0], dur: 19 },
      { color: "#fb923c", size: 380, x: "30%", y: "-5%", dx: [0, -30, 0], dy: [0, 50, 0], dur: 14 },
      { color: "#34d399", size: 320, x: "80%", y: "-10%", dx: [0, -40, 0], dy: [0, 30, 0], dur: 17 },
    ],
  };

  const orbs = orbConfigs[variant] || orbConfigs.default;

  const bgGradient = variant === "superadmin"
    ? "linear-gradient(135deg, #f0e6f6 0%, #e8f0fe 30%, #fef3e2 60%, #e8e0f0 100%)"
    : "linear-gradient(135deg, #e8f0fe 0%, #f0e6f6 30%, #fef3e2 60%, #e0f5f0 100%)";

  return (
    <div
      className={`glass-layout relative min-h-screen ${className}`}
      style={{ background: bgGradient, fontFamily: "Manrope, Inter, system-ui, sans-serif" }}
    >
      {/* Animated orbs */}
      <div className="pointer-events-none fixed inset-0 overflow-hidden z-0">
        {orbs.map((orb, i) => (
          <motion.div
            key={i}
            className="absolute rounded-full"
            style={{
              width: orb.size,
              height: orb.size,
              background: `radial-gradient(circle, ${orb.color} 0%, transparent 70%)`,
              left: orb.x,
              top: orb.y,
              opacity: 0.35,
            }}
            animate={{ x: orb.dx, y: orb.dy, scale: [1, 1.1, 1] }}
            transition={{ duration: orb.dur, repeat: Infinity, ease: "easeInOut" }}
          />
        ))}
      </div>
      {/* Content */}
      <div className="relative z-10">
        {children}
      </div>
    </div>
  );
}
